import * as React from "react";
import NumberFormat from "react-number-format";
import { Input } from "components/input";

export type PaymentDollarInputProps = {
  value: number | undefined | null;
  onValueChange: (value: number | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  autoFocus?: boolean;
  className?: string;
  "data-testid"?: string;
};

/**
 * Dollar input for the payment/void flow. Supports amounts &lt; $1, empty state,
 * and works well with controlled caps (max applied per invoice, refund amount).
 * Value is in dollars (e.g. 0.5 = $0.50).
 */
export default function PaymentDollarInput({
  value,
  onValueChange,
  placeholder,
  disabled,
  maxLength = 20,
  autoFocus,
  className,
  ...rest
}: PaymentDollarInputProps) {
  const displayValue =
    value === undefined || value === null ? "" : String(value);

  return (
    <NumberFormat
      customInput={Input}
      prefix="$"
      thousandSeparator={true}
      decimalScale={2}
      fixedDecimalScale={false}
      allowLeadingZeros
      isNumericString
      value={displayValue}
      onValueChange={(e) => {
        const next = e.floatValue;
        onValueChange(next === undefined ? undefined : next);
      }}
      placeholder={placeholder}
      disabled={disabled}
      maxLength={maxLength}
      autoFocus={autoFocus}
      className={className}
      {...rest}
    />
  );
}
